import { useState } from 'react';

import Button from '@/components/BaseLibrary/Button/Button';
import Dropdown from '@/components/BaseLibrary/Dropdown/Dropdown';
import useStyles from '@/components/InteractiveQuoteForm/InteractiveQuoteForm.styles';
import { trackEvents } from '@/utils/analytics';

export interface BillRangeStepProps {
  handleNext: (data: string) => void;
}

const billAmounts: string[] = [
  '$0-50',
  '$51-100',
  '$101-150',
  '$151-200',
  '$201-300',
  '$301-400',
  '$401-500',
  '$501-600',
  '$601-700',
  '$701-800',
  '$801+',
];

export default function BillRangeStep({ handleNext }: BillRangeStepProps) {
  const { classes } = useStyles();

  const [option, setOption] = useState<string>('');

  const onSubmit = (data: string) => {
    trackEvents({
      event: 'Form_cta_click',
      Form_tab: 'Avg Electric Bill',
      Form_step: 3,
      click_text: 'Next',
    });
    handleNext(data);
  };

  return (
    <div className={classes.inputContainer}>
      <Dropdown
        label='Avg Electric Bill'
        options={billAmounts}
        onChange={(selected) => setOption(selected)}
        placeholder='Select a range'
      />
      <div className={classes.buttonContainer}>
        <Button
          onClick={() => onSubmit(option)}
          label='Next'
          disabled={option.length === 0}
          className={classes.button}
        />
      </div>
    </div>
  );
}
